<template>
  <div>
    <b-modal
      footer="{null}"
      centered
      :id="id"
      title="Régler plusieurs factures"
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      @hidden="retryProcess"
      class="position-relative"
    >
      <div class="position-relative">
        <div class="facture-infos">
          <div
            v-for="(facture, index) in factures_datas"
            :key="index"
            class="py-3 px-3 facture-block"
          >
            <div class="w-100">
              <span><b>N°: </b> </span>
              <span>
                <b>{{ facture.invoice_number }}</b>
              </span>
            </div>
            <div class="w-100">
              <span><b>Montant: </b></span>
              <span>
                {{ facture.invoice_amount + " FCFA" }}
              </span>
            </div>
            <div class="w-100">
              <span><b>Reste à payer: </b></span>
              <span>
                {{ facture.invoice_outstanding + " FCFA" }}
              </span>
            </div>
          </div>
        </div>
        <div class="payment-block position-relative">
          <div v-if="current_step == 1">
            <div
              class="text-center"
              id="b2b_payment_overlay"
              v-if="is_processing"
            >
              <div>
                <div id="loading-bg" class="">
                  <div class="loading">
                    <div class="effect-1 effects"></div>
                    <div class="effect-2 effects"></div>
                    <div class="effect-3 effects"></div>
                  </div>
                  <div class="loading-text">Traitement en cours ...</div>
                </div>
              </div>
            </div>

            <div v-if="total_amount > 0">
              <div class="text-center pt-3 pb-2">
                <div class="form-group text-center">
                  <div class="text-muted mb-1">Montant total</div>
                  <h3 class="red-color mb-1">{{ total_amount }} FCFA</h3>
                </div>
              </div>
              <ValidationObserver v-slot="{ handleSubmit }">
                <b-form @submit.prevent="handleSubmit(creditAccount)">
                  <b-form-group
                    id="input-group-1"
                    description="Numéro Momo à débiter"
                    label-for="input-1"
                    class="px-3"
                    :class="queued_message.trim() !== '' ? 'pb-5' : ''"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      rules="required|phone"
                    >
                      <b-form-input
                        id="input-1"
                        v-model="form.momo_phone"
                        type="number"
                        placeholder="Ex: 97979797"
                      ></b-form-input>
                      <VFieldErrors :errors="errors" class="w-100" />
                    </validation-provider>
                  </b-form-group>
                  <div class="modal-footer d-flex justify-content-center">
                    <div class="py-3">
                      <button
                        type="submit"
                        :disabled="is_loading"
                        class="btn btn-dark"
                        v-if="is_processing === false"
                      >
                        <b-spinner
                          small
                          v-if="is_loading"
                          label="Loading..."
                        ></b-spinner>
                        <span v-if="!is_loading">Valider</span>
                      </button>
                    </div>
                    <div
                      v-if="queued_message.trim() !== ''"
                      class="modal-globa-notification"
                      v-html="queued_message"
                    ></div>
                  </div>
                </b-form>
              </ValidationObserver>
            </div>
            <div class="px-5 py-4" v-if="total_amount <= 0">
              <div class="fw-bold text-center p-4">
                <h5>Vous n'avez rien à payer.</h5>
                <div>
                  Veuillez sélectionner au moins une facture <br />
                  impayée ou
                  <a class="action-link" @click="open_modal('credit_account')"
                    ><b>Payer en avance</b></a
                  >
                  <CreditAccount :id="'credit_account'" />
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="current_step == 2"
            class="
              payment-status-block
              d-flex
              align-items-center
              justify-content-center
              py-4
              px-5
            "
          >
            <div
              class="d-flex justify-content-center align-items-center"
              v-if="current_status_datas.status == 'successful'"
            >
              <div class="text-center">
                <svg
                  class="mb-2"
                  fill="#00a92d"
                  enable-background="new 0 0 59.032 59.032"
                  viewBox="0 0 59.032 59.032"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g>
                    <g id="_19-confirmation">
                      <path
                        d="m51.678 24.302c-.706-.826-1.948-.923-2.774-.217l-6.592 5.647v-21.212c0-4.706-3.815-8.52-8.52-8.52h-18.38c-4.706 0-8.52 3.815-8.52 8.52v41.992c0 4.706 3.815 8.52 8.52 8.52h18.379c4.706 0 8.52-3.815 8.52-8.52v-15.585l9.15-7.871c.813-.704.91-1.931.217-2.754zm-36.266-20.367h18.379c2.299-.023 4.259 1.66 4.585 3.935h-27.549c.326-2.275 2.286-3.958 4.585-3.935zm18.379 51.162h-18.379c-2.299.023-4.259-1.66-4.585-3.935h27.548c-.325 2.275-2.285 3.958-4.584 3.935zm4.585-7.871h-27.549v-35.42h27.548v21.311l-1.869 1.594-4.605-4.624c-.772-.772-2.023-.772-2.794 0-.772.772-.772 2.023 0 2.794l5.903 5.903c.371.368.874.574 1.397.571.469 0 .923-.167 1.279-.472l.689-.59v8.933zm-23.613-29.516c0-1.087.881-1.968 1.968-1.968h15.742c1.087 0 1.968.881 1.968 1.968s-.881 1.968-1.968 1.968h-15.742c-1.087-.001-1.968-.882-1.968-1.968zm0 7.871c0-1.087.881-1.968 1.968-1.968h15.742c1.087 0 1.968.881 1.968 1.968s-.881 1.968-1.968 1.968h-15.742c-1.087-.001-1.968-.882-1.968-1.968zm0 7.871c0-1.087.881-1.968 1.968-1.968h5.903c1.087 0 1.968.881 1.968 1.968s-.881 1.968-1.968 1.968h-5.903c-1.087-.001-1.968-.882-1.968-1.968zm19.677 7.871c0 1.087-.881 1.968-1.968 1.968h-15.741c-1.087 0-1.968-.881-1.968-1.968s.881-1.968 1.968-1.968h15.742c1.086 0 1.967.881 1.967 1.968z"
                      />
                    </g>
                  </g>
                </svg>
                <h5>Paiement effectué</h5>
                <p>
                  Le paiement de <b>{{ total_amount }} FCFA</b> a été effectué
                  pour le règlement <br />
                  de vos factures pour les périodes de <br />
                  <span v-for="(facture, index) in factures_datas" :key="index">
                    <b>{{ facture.invoice_date }}</b>
                  </span>
                </p>
                <div class="mb-3">
                  <a
                    class="download-recu"
                    :href="`https://my.mtn.bj/b2b-receipt/?id=${external_reference}`"
                    target="_blank"
                    >Télécharger le reçu</a
                  >
                </div>
              </div>
            </div>
            <div
              class="text-center"
              v-if="current_status_datas.status == 'pending'"
            >
              <div>
                <div class="mb-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 256 256"
                    fill="#004F71"
                  >
                    <path
                      d="M71.215,215.155a4,4,0,0,1-3.94-4.719c7.832-42.887-9.4-68.372-9.579-68.624a4.015,4.015,0,0,1-.066-4.477c2.561-3.918,4.416-15.276,4.511-27.622.116-15.27-2.375-22.627-3.53-23.639A10.582,10.582,0,0,0,48.681,85a7.355,7.355,0,0,0-4.61,5.935c-.778,5.062-3.188,12.234-5.978,20.54-3.078,9.163-6.568,19.548-8.211,28.386a177.97,177.97,0,0,0-2.689,32.232,4,4,0,0,1-1.015,2.761L10.508,192.4a4,4,0,1,1-5.967-5.329l14.636-16.386a184.2,184.2,0,0,1,2.84-32.284c1.747-9.39,5.331-20.058,8.493-29.471,2.561-7.625,4.98-14.826,5.655-19.209a15.375,15.375,0,0,1,9.427-12.1,18.6,18.6,0,0,1,17.727,1.985c9.464,6.835,8.189,46.059,2.258,59.724,4.276,7.283,16.812,32.877,9.568,72.542A4,4,0,0,1,71.215,215.155Z"
                    />
                    <path
                      d="M64.388,251.1a4,4,0,0,1-2.881-6.775l13.644-14.168A4,4,0,0,1,78.77,229c.147.028,15.7,2.785,28.959-3.844.2-.1,13.562-6.608,18.228-17.945a4,4,0,0,1,7.4,3.045c-5.857,14.232-21.459,21.777-22.121,22.091-12.606,6.3-26.455,5.471-31.744,4.838l-12.221,12.69A3.99,3.99,0,0,1,64.388,251.1Z"
                    />
                    <path
                      d="M175.661,118.532a4,4,0,0,1-4-4v-96.8c0-5.3-5.111-9.607-11.394-9.607h-83.9c-6.284,0-11.4,4.31-11.4,9.607V82.85a4,4,0,0,1-8,0V17.729c0-9.708,8.7-17.607,19.4-17.607h83.9c10.694,0,19.394,7.9,19.394,17.607v96.8A4,4,0,0,1,175.661,118.532Z"
                    />
                    <path
                      d="M106.063,207.485H73.8a4,4,0,0,1,0-8h32.268a4,4,0,0,1,0,8Z"
                    />
                    <path
                      d="M175.028,29.673H61.258a4,4,0,0,1,0-8h113.77a4,4,0,0,1,0,8Z"
                    />
                    <path
                      d="M93.553,184.747H74.683a4,4,0,1,1,0-8h18.87a4,4,0,0,1,0,8Z"
                    />
                    <path
                      d="M178.769,255.879a4,4,0,0,1-3.665-2.392l-3.542-8.064-21.128-9.642a4.036,4.036,0,0,1-1.227-.871l-40.348-42.092q-.064-.068-.126-.138c-.545-.624-5.264-6.266-3.379-12.162,1.209-3.786,4.615-6.373,10.12-7.689,9.744-2.329,21.675,4.472,29.541,10.167l-32.4-73.751a14.877,14.877,0,0,1-.359-11.207,14.155,14.155,0,0,1,7.623-8.129,14.624,14.624,0,0,1,19.153,7.731,4,4,0,0,1-7.324,3.218,6.622,6.622,0,0,0-8.612-3.625,6.228,6.228,0,0,0-3.338,3.584,6.915,6.915,0,0,0,.181,5.21l35.233,80.207a4,4,0,0,1,.26,2.4l-.962,4.79a4,4,0,0,1-6.64,2.148c-5.32-4.916-21.179-17.2-30.5-14.958-2.875.687-4.136,1.658-4.357,2.337-.355,1.087.791,3.274,1.746,4.426l39.73,41.448,21.819,9.957a4,4,0,0,1,2,2.031l4.157,9.46a4,4,0,0,1-3.66,5.61Z"
                    />
                    <path
                      d="M165.188,171.117a4,4,0,0,1-3.665-2.392l-29.812-67.867a4,4,0,0,1,7.324-3.218l29.813,67.867a4,4,0,0,1-3.66,5.61Z"
                    />
                    <path
                      d="M155.483,149.026a4,4,0,0,1-3.664-2.391,14.877,14.877,0,0,1-.359-11.207,14.186,14.186,0,0,1,18.766-8.244,14.879,14.879,0,0,1,8.009,7.846,4,4,0,1,1-7.324,3.217,6.914,6.914,0,0,0-3.714-3.658,6.187,6.187,0,0,0-8.235,3.618,6.908,6.908,0,0,0,.182,5.209,4,4,0,0,1-3.661,5.61Z"
                    />
                    <path
                      d="M185.02,164.416a4,4,0,0,1-3.665-2.393l-10.444-23.775a4,4,0,0,1,7.324-3.218l10.445,23.776a4,4,0,0,1-3.66,5.61Z"
                    />
                    <path
                      d="M178.353,149.236a4,4,0,0,1-3.665-2.391,14.877,14.877,0,0,1-.359-11.207,14.184,14.184,0,0,1,18.766-8.244,14.876,14.876,0,0,1,8.009,7.846,4,4,0,1,1-7.324,3.217,6.914,6.914,0,0,0-3.714-3.658,6.185,6.185,0,0,0-8.235,3.618,6.908,6.908,0,0,0,.182,5.209,4,4,0,0,1-3.66,5.61Z"
                    />
                    <path
                      d="M205.992,160.307a4,4,0,0,1-3.664-2.392l-8.548-19.457a4,4,0,0,1,7.324-3.218l8.548,19.457a4,4,0,0,1-3.66,5.61Z"
                    />
                    <path
                      d="M201.059,149.076a4,4,0,0,1-3.664-2.392,14.431,14.431,0,1,1,26.417-11.6,4,4,0,1,1-7.325,3.219,6.436,6.436,0,1,0-11.768,5.169,4,4,0,0,1-3.66,5.609Z"
                    />
                    <path
                      d="M248.478,226.778a4,4,0,0,1-3.665-2.392l-3.854-8.775a4,4,0,0,1-.33-1.865l1.147-17.877L216.487,138.3a4,4,0,0,1,7.325-3.217l25.681,58.463a4,4,0,0,1,.33,1.866l-1.147,17.877,3.462,7.882a4,4,0,0,1-3.66,5.61Z"
                    />
                  </svg>
                </div>
                <h5>Confirmer votre paiement</h5>
                <p>
                  Veuillez confirmer le paiement de
                  <b>{{ total_amount }} FCFA</b> par MoMo. Si vous ne recevez
                  pas le prompt de validation, veuillez composez *880# et allez
                  dans les validations.
                </p>
                <div class="d-flex justify-content-center">
                  <div class="bullet-spinner">
                    <div class="bounce1"></div>
                    <div class="bounce2"></div>
                    <div class="bounce3"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div></div>
    </b-modal>
  </div>
</template>

<script>
import VFieldErrors from "@/components/utils/VFieldsErrors";
import { subscriber } from "@/services/";
import {
  required,
  length,
  phone,
  min_amount,
  email,
} from "vee-validate/dist/rules";
import { extend } from "vee-validate";
import _ from "lodash";
import CreditAccount from "./CreditAccount.vue";
extend("required", {
  ...required,
  message: "Champ obligatoire",
});
extend("min_amount", (value) => {
  return parseInt(value) >= 1;
});
extend("phone", (value) => {
  let authorized_max_lengths = store.state.settings?.phone_prefixes?.msisdn_length ?? [10];
  const prefixes = store.state.settings?.phone_prefixes?.mtn ?? [];

  let prefixIncluded = prefixes.some((pr) => value.toString().startsWith(pr));
  const lengthOf = value.toString().length;
  return prefixIncluded && authorized_max_lengths.includes(lengthOf);
});
extend("phone", {
  ...phone,
  name: "téléphone",
  message: "Le numéro de téléphone est invalide",
});
extend("min_amount", {
  ...min_amount,
  name: "name",
  message: "Le montant minimum est de 1 FCFA",
});
extend("email", {
  ...email,
  name: "name",
  message: "Email invalide",
});
export default {
  props: {
    id: {
      type: String,
      default: "",
    },
    factures_datas: {
      type: Array,
      default: () => [],
    },
  },
  name: "PayFacture",
  components: {
    VFieldErrors,
    CreditAccount,
  },
  data: () => {
    return {
      form: {
        momo_phone: "",
      },
      total_amount: 0,
      is_loading: false,
      is_processing: false,
      current_step: 1,
      current_status_datas: {},
      queued_message: "",
      recu_mode: [],
      external_reference: "",
    };
  },
  created() {
    this.getTotalAmount;
  },
  computed: {
    getTotalAmount() {
      this.total_amount = this.factures_datas.reduce((accumulator, element) => {
        return accumulator + element.invoice_outstanding;
      }, 0);
    },

    getTransactionsNumbers() {
      let transactions_numbers = [];
      for (let index = 0; index < this.factures_datas.length; index++) {
        if (this.isNotPaid(this.factures_datas[index].invoice_outstanding)) {
          transactions_numbers.push(this.factures_datas[index].invoice_number);
        }
      }
      return transactions_numbers;
    },

    canRetry() {
      return (
        this.current_status_datas.status === "failed" ||
        this.current_status_datas.status === "already_queued"
      );
    },
  },
  methods: {
    isNotPaid(element) {
      if (element > 0) {
        return true;
      } else {
        return false;
      }
    },
    async creditAccount() {
      this.current_status_datas = {};
      this.is_loading = true;
      const data = {
        ref_code: this.form.momo_phone,
        amount: this.total_amount,
        transaction_number: this.getTransactionsNumbers,
      };
      await subscriber.get_bills_pay_bill(data).then((response) => {
        this.is_loading = false;
        if (!_.isUndefined(response.error)) {
          return;
        } else if (_.isUndefined(response.error)) {
          if (
            !_.isUndefined(response.response_error_code) &&
            !_.isUndefined(response.abillity_reference)
          ) {
            let final_payment_status = "";
            if (
              response.abillity_reference.trim() !== "" &&
              response.response_error_code == 0
            ) {
              this.is_processing = true;
              this.external_reference = response.abillity_reference;
              let status_checker = setInterval(async () => {
                await subscriber
                  .checkPaymentStatus(response.abillity_reference)
                  .then((resp) => {
                    if (!_.isUndefined(resp.status)) {
                      final_payment_status = resp.status;
                      this.current_status_datas =
                        this.$store.state.core.business_account.payment_status_datas[
                          final_payment_status
                        ];
                      if (resp.status == "pending") {
                        this.current_step = 2;
                        this.current_status_datas =
                          this.$store.state.core.business_account.payment_status_datas[
                            "pending"
                          ];
                      }
                      if (resp.status == "failed") {
                        clearInterval(status_checker);
                        this.is_processing = false;
                        this.current_step = 1;
                        this.queued_message =
                          this.$store.state.core.business_account.payment_status_datas[
                            final_payment_status
                          ].message;
                      }
                      if (resp.status == "successful") {
                        clearInterval(status_checker);
                        this.current_step = 2;
                        this.current_status_datas =
                          this.$store.state.core.business_account.payment_status_datas[
                            final_payment_status
                          ];
                      }
                    } else {
                      clearInterval(status_checker);
                      this.current_step = 2;
                      this.current_status_datas =
                        this.$store.state.core.business_account.payment_status_datas[
                          "failed"
                        ];
                    }
                  });
              }, 2000);
            } else {
              if (response.already_queued == true) {
                this.queued_message = response.response_desc_lang_2;
              }
            }
          }
        }
      });
    },
    retryProcess() {
      this.current_step = 1;
      this.is_processing = false;
      this.current_status_datas = {};
      this.queued_message = "";
    },
  },
  watch: {
    factures_datas() {
      this.getTotalAmount;
      this.getTransactionsNumbers;
    },
  },
};
</script>
<style scoped lang="css">
::v-deep .modal-body {
  overflow-y: auto !important;
  position: relative !important;
  font-size: 14px !important;
  max-height: 500px !important;
}
.content-title {
  font-size: 16px !important;
  font-weight: 500 !important;
}
.facture-block {
  border-bottom: 1.5px solid #f2f2f2 !important;
}
::v-deep .badge {
  color: #fff;
  font-weight: 400 !important;
  padding: 4px 8px !important;
  font-size: 10px !important;
}
.paid {
  background: #00b110 !important;
}
.unpaid {
  background-color: #d81822 !important;
}
i.pending {
  color: #ffad1f !important;
}
::v-deep .modal-body {
  padding: 0px !important;
}
.modal-footer {
  box-shadow: 0 0px 0px rgb(0 0 0 / 10%) !important;
  background: #ffffff !important;
  position: sticky;
  bottom: 0;
  background: #ffffff;
  margin-bottom: 0 !important;
}
.modal-footer > * {
  margin: 0;
}
.payment-block {
  background: #f2f2f2 !important;
  border-bottom-left-radius: calc(0.3rem - 1px);
  border-bottom-right-radius: calc(0.3rem - 1px);
}
.key {
  font-weight: 600;
  margin-right: 4px !important;
}
.btn-dark {
  background-color: #000000 !important;
}
::v-deep input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0 !important;
}
/* Firefox */
::v-deep input[type="number"] {
  -moz-appearance: textfield !important;
}
.modal-footer {
  box-shadow: 0 0px 0px rgb(0 0 0 / 10%) !important;
  background: #ffffff !important;
  position: sticky;
  bottom: 0;
  background: #ffffff;
  margin-bottom: 0 !important;
}
#b2b_payment_overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(242, 242, 242, 0.8);
  z-index: 200;
  left: 0;
  top: 0;
  display: table;
  text-align: center;
}

#b2b_payment_overlay > div {
  display: table-cell;
  vertical-align: middle;
}
#loading-bg {
  width: 100%;
  height: 100%;
}
.logo {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 20px;
}
.loading {
  position: absolute;
  left: calc(50% - 28px);
  top: calc(50% - 28px);
  width: 56px;
  height: 56px;
  border-radius: 50%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: 4px solid transparent;
}
.loading-text {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding-top: 110px !important;
  box-sizing: border-box !important;
  color: #000000 !important;
  font-weight: 600 !important;
}
.loading .effect-1,
.loading .effect-2 {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 4px solid transparent;
  border-left: 4px solid #000;
  border-radius: 50%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.loading .effect-1 {
  animation: rotate 1s ease infinite;
}
.loading .effect-2 {
  animation: rotateOpacity 1s ease infinite 0.1s;
}
.loading .effect-3 {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 4px solid transparent;
  border-left: 4px solid #000;
  -webkit-animation: rotateOpacity 1s ease infinite 0.2s;
  animation: rotateOpacity 1s ease infinite 0.2s;
  border-radius: 50%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.loading .effects {
  transition: all 0.3s ease;
}
.payment-status-block i {
  font-size: 62px !important;
}
.payment-status-block svg {
  height: 62px !important;
}
i.successful {
  color: #00b110 !important;
}
.red-color,
i.already_queued,
i.failed,
i.mdi.mdi-alert-circle.failed {
  color: #d81822 !important;
}

@keyframes rotate {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn);
  }
}
@keyframes rotateOpacity {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
    opacity: 0.1;
  }
  100% {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn);
    opacity: 1;
  }
}
.action-link {
  color: #004f71;
  font-size: 14px;
  font-weight: 500 !important;
  cursor: pointer !important;
}
.action-link:hover,
.action-link:active {
  text-decoration: underline !important;
  text-decoration-color: #004f71;
}
.bullet-spinner {
  width: 70px;
  text-align: center;
}

.bullet-spinner > div {
  width: 18px;
  height: 18px;
  background-color: #004f71;

  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.bullet-spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.bullet-spinner .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

@-webkit-keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
  }
}

@keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
.modal-globa-notification {
  background: #d81822;
  position: absolute;
  bottom: 67px;
  width: 100%;
  left: 0;
  color: #fff;
  text-align: center;
  padding: 10px;
  z-index: 100;
}
.spinner-border {
  height: 20px !important;
  width: 20px !important;
}
</style>